<template>
  <div data-v-7b1e8ab4="" data-v-011e1fb8="" class="agJackpot2022 mainContent top50 centered-container" v-if="dataInfo.title" style="background: #fafafa;">
    <!-- 主banner图片，设置为居中显示 -->
    <img :src="dataInfo.banner" alt="活动banner" class="centered-banner" />
    
    <!-- 信息内容盒子，设置最大宽度并居中 -->
    <div class="infoBoxz centered-content">
      <div class="tit">{{ dataInfo.title }}</div>
      <div v-html="dataInfo.content" class="content"></div>
      <div v-html="dataInfo.memo" class="memo"></div>
    </div>
    
    <!-- 参与按钮，保持居中 -->
    <img data-v-7b1e8ab4="" @click="doactivityapply" class="participate-btn" src="/static/style/canyubtn.png" alt="参与活动按钮" />
  </div>
</template>

<script>
export default {
  name: 'discountInfo',
  data() {
    return { dataInfo: {} };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    doactivityapply() {
      let that = this;
      that.$parent.showLoading();
      
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id }).then(res => {
        that.$parent.showTost(1, res.message);
        that.$parent.hideLoading();
      });
    },
    getInfo(id) {
      let that = this;
      that.$parent.showLoading()
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading()
      });
    }
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-6cc178e1.70a3ba40.css';
@import '../../../static/css/chunk-009dfcc3.a4bf2976.css';
@import '../../../static/css/chunk-1225a5b6.b06a16a7.css';
@import '../../../static/css/chunk-639bacf2.80f975ef.css';
@import '../../../static/css/chunk-1bfc786f.3344e98f.css';
@import '../../../static/css/chunk-9c01ee94.ae6edd11.css';
@import '../../../static/css/chunk-4a9bbb2b.cbe5dff6.css';

// 隐藏不需要的元素
.faq .faq-container .row .group .a-row[data-v-3ecdc100] {
  display: none;
}

// 主容器样式，实现整体居中
.centered-container {
  max-width: 1200px; // 设置最大宽度，避免在宽屏上过度拉伸
  margin: 0 auto; // 水平居中
  padding: calc(env(safe-area-inset-top) + 100px) 20px 20px;

}

// Banner图片居中样式
.centered-banner {
  display: block;
  margin: 0 auto;
  max-width: 100%; // 响应式，不超过容器宽度
  height: auto; // 保持图片比例
}

// 内容盒子居中样式
.centered-content {
  background: rgb(255, 255, 255);
  box-sizing: border-box;
  padding: 50px;
  margin: 0 auto; // 确保内容盒子在容器中居中
  max-width: 1000px; // 内容区最大宽度
}

// 标题样式
.tit {
  font-size: 26px;
  font-weight: 600;
  text-align: center; // 文本居中
  height: 60px;
  line-height: 60px;
  margin-bottom: 20px; // 增加底部间距
}

// 内容区域样式
.content, .memo {
  line-height: 1.8; // 改善文本可读性
  text-align: justify; // 文本两端对齐，更美观
}

// 参与按钮样式
.participate-btn {
  margin: 50px auto;
  display: block;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/allMode/discountInfo.vue